var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"formData",attrs:{"options":_vm.formData.transferType != 'TT03' ? _vm.options : _vm.TT03Options,"disabled":!_vm.canEdit,"label-width":"100px"},on:{"input":_vm.handleChange},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }